import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import axios from 'axios';
import App from './App';
import 'dotenv'
import { Loader } from './components/Loader/Loader';
import './style.css';
import './i18n';
import { AppProvider } from './AppContext';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

ReactDOM.render(
    <Suspense fallback={<Loader />}>
        <AppProvider>
            <Router>
                <Switch>
                    <Route path='/:lang?/:name?/:layer?/:lng?/:lat?/:zoom?/:height?/:yaw?/:pitch?/:roll?/:splitType?/:splitLayer?' component={App} />
                </Switch>
            </Router>
        </AppProvider>
    </Suspense>,
    document.getElementById('root')
);
